<script>
import { latLng } from "leaflet";
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker'

export default {
  name: "Example",
  components: {
    'v-rotated-marker': Vue2LeafletRotatedMarker
  },
  props: {
    lat: {
      type: Number,
      required: true,
    },
    long: {
      type: Number,
      required: true,
    },
    direction: {
      type: Number,
      required: false,
    },
    markerIcon: {
      type: undefined,
      required: false,
    }
  },
  data() {
    return {
      zoom: 15,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      mapReady: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.mapReady = true
      }, 500);
    });
  },
  computed: {
    center() {
      return latLng(this.lat, this.long)
    },
  },
};
</script>

<template>
  <div v-if="mapReady" style="height: 100%; width: 100%;">
    <l-map :zoom="zoom" :center="center" style="height: 100%; width: 100%">
      <l-tile-layer :url="url" />
      <v-rotated-marker :lat-lng="center" :icon="markerIcon" :rotation-angle="direction"></v-rotated-marker>
    </l-map>
  </div>
  <b-skeleton-img height="100%" v-else></b-skeleton-img>
</template>
